import React from 'react';
import { connect } from 'react-redux';
import ValueReferenceSelector from './value-reference-selector';
import ValueSource from '../../sources/value';
import { isEmpty } from 'ramda';

class ValueSelectorTable extends React.Component {

    constructor(props) {
        super(props);
        this.getObjectDataRequest = this.getObjectDataRequest.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    getObjectDataRequest(contentType, typeElementId) {
        const objectDataRequest = {
            stateId: manywho.utils.extractStateId(this.props.flowKey),
            typeElementBindingId: "ecf9e2b7-1d3a-4ca7-8d8c-53dad545a329",
            listFilter: {
                limit: -1,
                offset: 0,
                comparisonType: "AND",
                where: [],
            },
            objectDataType: {
                typeElementId: "0cae1572-df7a-481e-ac73-74dd08b72b92",
                developerName: "ValueElementIdReference",
                properties: [
                    { developerName: "DeveloperName" },
                    { developerName: "TypeElementDeveloperName" },
                    { developerName: "TypeElementPropertyDeveloperName" },
                    { developerName: "TypeElementPropertyTypeElementId" },
                    { developerName: "ElementType" },
                    { developerName: "TypeElementId" },
                    { developerName: "ServiceElementId" },
                    { developerName: "ServiceElementDeveloperName" },
                    { developerName: "ContentType" },
                    { developerName: "IsFixed" },
                    { developerName: "Access" },
                    { developerName: "Id" },
                    { developerName: "TypeElementPropertyId" },
                    { developerName: "Command" }
                ]
            }
        }

        if (contentType)
            objectDataRequest.listFilter.where.push({ columnName: 'ContentType', value: contentType.contentValue, criteriaType: 'EQUAL' });

        if (typeElementId && !isEmpty(typeElementId.contentValue))
            objectDataRequest.listFilter.where.push({ columnName: 'TypeElementId', value: typeElementId.contentValue, criteriaType: 'EQUAL' });

        return objectDataRequest;
    }

    onChange(value, id) {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        const state = manywho.state.getComponent(this.props.id, this.props.flowKey);

        let flowId = null;
        if (model.tags)
            flowId = model.tags.find((tag) => manywho.utils.isEqual(tag.developerName, 'FlowId', true));

        if (value && flowId && !manywho.utils.isNullOrWhitespace(flowId.contentValue)) {
            const valueId = manywho.utils.getObjectDataProperty(value.properties, 'Id').contentValue;
            ValueSource.import(valueId, flowId.contentValue, this.props.tenantId, this.props.authenticationToken);
        }

        state.objectData = state.objectData.map((item) => {
            if (item.externalId === id) {
                item.properties = item.properties.map((prop) => {
                    if (prop.developerName === model.attributes.valueReference)
                        prop.objectData = (value) ? [value] : null;
                    return prop;
                });
            }
            return item;
        });

        manywho.state.setComponent(this.props.id, state, this.props.flowKey, true);
        this.forceUpdate();
    }

    render() {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        const state = manywho.state.getComponent(this.props.id, this.props.flowKey);
        let values = null;

        if (!this.props.isDesignTime && state.objectData) {
            let newValueName = null;

            const newValueNamePrefix = model.tags ? model.tags.find(tag => manywho.utils.isEqual(tag.developerName, 'NewValueNamePrefix', true)) : null;
            if (newValueNamePrefix)
                newValueName = newValueNamePrefix.contentValue + ': ';

            values = state.objectData.map((item) => {
                let propertyName = manywho.utils.getObjectDataProperty(item.properties, 'DeveloperName').contentValue;

                const value = manywho.utils.getObjectDataProperty(item.properties, model.attributes.valueReference).objectData;
                const contentType = manywho.utils.getObjectDataProperty(item.properties, 'ContentType');
                const typeElementId = manywho.utils.getObjectDataProperty(item.properties, 'TypeElementId');

                const objectDataRequest = this.getObjectDataRequest(contentType, typeElementId);

                return (<tr key={item.externalId}>
                    <td>{propertyName}</td>
                    <td>
                        <ValueReferenceSelector value={(value) ? value[0] : null} onChange={this.onChange} objectDataRequest={objectDataRequest} id={item.externalId} authenticationToken={manywho.state.getAuthenticationToken(this.props.flowKey)} name={newValueName || '' + propertyName} />
                    </td>
                </tr>);
            })
        }

        const label = !manywho.utils.isNullOrWhitespace(model.label) && <h4>{model.label}</h4>;

        return (<div className="value-selector-table" key={this.props.id}>
                    {label}
                    <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Value</th>
                        </tr>
                        {values}
                    </tbody>
                </table>
            </div>);
    }

}

export default connect(
    ({ currentUser: { authenticationToken, tenantId } }) => ({ authenticationToken, tenantId }),
)(ValueSelectorTable);
